import get from 'lodash/get'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Menu from '../../components/menu/constants'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

const selectCommunityIdentifier = (a: Router.OnEnterAction) => get(a, 'params.communityIdentifier', null)

export const fetchConfigPage = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.COMMUNITY_CONFIG_URL))
  .map(selectCommunityIdentifier)
  .filter((communityIdentifier) => store.getState().app.selectedCommunity === communityIdentifier)
  .map(Actions.fetchCommunityConfig)

export const selectCommunityForConfigPage = (
  action$: ReduxObservable.ActionsObservable<Router.OnEnterAction>,
  store: Redux.Store<any>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.COMMUNITY_CONFIG_URL))
  .map(selectCommunityIdentifier)
  .filter((communityIdentifier) => store.getState().app.selectedCommunity !== communityIdentifier)
  .map(App.selectCommunity)

export const flashUploadedUrl = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<any>,
) => action$.ofType(Request.successConstant(Constants.UPLOAD_IMAGE))
  .map((action: any) => action.payload.response.image_url)
  .map((url: string) => Flash.showFlashMessage('Image uploaded to ' + url))

export const epic = ReduxObservable.combineEpics(
  fetchConfigPage,
  flashUploadedUrl,
  selectCommunityForConfigPage,
)



// WEBPACK FOOTER //
// ./src/pages/community-config/epic.ts